<div class="container">
  <app-static-second-factor
    [btnText]="isActivationDialog ? 'Activar' : 'Desactivar'"
    [textCode]="
      isActivationDialog ? 'Código de asociación del autenticador' : 'Código del autenticador'
    "
    [title]="isActivationDialog ? 'Activación de 2FA' : 'Desactivación de 2FA'"
    [subtitle]="
      isActivationDialog
        ? 'Asociá tu cuenta con un autenticador'
        : 'Desasociá tu cuenta de un autenticador'
    "
    [invalidCode]="invalidCode"
    (valueCode)="fillCode($event)"
    (sendCode)="enterPressed()"
  >
    <div class="activation-container add-section">
      <div class="qr-section" *ngIf="isActivationDialog">
        <div class="qr-container" [class.hide]="qrLoading">
          <qrcode
            [qrdata]="otpauthURL"
            [width]="256"
            [imageHeight]="50"
            [imageWidth]="50"
            errorCorrectionLevel="M"
          ></qrcode>
        </div>
        <div class="loading" *ngIf="qrLoading">
          <div class="circle-loader">
            <div class="checkmark draw"></div>
          </div>
        </div>
      </div>
      <div class="back-up-section">
        <p class="back-up" *ngIf="!qrLoading" (click)="toggleBackUp()">
          {{ showBackUpCode ? 'Ocultar código de backup' : 'Ver código de backup' }}
        </p>
        <p class="back-up-code" *ngIf="showBackUpCode">{{ qrBackUpCode }}</p>
      </div>
    </div>
  </app-static-second-factor>
</div>
